// src/HouseholdContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { getUserHousehold } from "./householdService";

const HouseholdContext = createContext(null);

export function HouseholdProvider({ children }) {
  const { user } = useAuth();
  const [household, setHousehold] = useState(undefined); // undefined = loading

  useEffect(() => {
    // Still waiting on auth to resolve — stay in loading state
    if (user === undefined) {
      setHousehold(undefined);
      return;
    }
    // No user logged in — no household to load
    if (user === null) {
      setHousehold(null);
      return;
    }
    // User exists — reset to loading while we fetch their household
    setHousehold(undefined);
    let cancelled = false;
    getUserHousehold(user.uid).then(h => {
      if (!cancelled) setHousehold(h ?? null);
    });
    return () => { cancelled = true; };
  }, [user]);

  return (
    <HouseholdContext.Provider value={{ household, setHousehold }}>
      {children}
    </HouseholdContext.Provider>
  );
}

export const useHousehold = () => useContext(HouseholdContext);
